/*=========================================================================================
  File Name: moduleClientState.js
  Description: Client Module State
==========================================================================================*/


export default {
  client: {},
  clients: [],
  log: [],
}
